import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Grid,
  IconButton,
  TextField,
  Button,
  Switch,
} from "@mui/material";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { companyWiseEmp } from "../../actions/Companywiseclient";
import CloseIcon from "@mui/icons-material/Close";
import { CustomInputField } from "../CommonComponents/CustomCompontes";

function GpsNotificationConfiguration({ gpsLocationStatusObj, companyId }) {
  const [formData, setFormData] = React.useState({
    notificationTimeInterval: "",
    notificationCount: "",
    isEnable: false,
  });

  console.log(gpsLocationStatusObj, "objjjjjjjjj");

  const handleChange = (e) => {
    setFormData((formData) => ({
      ...formData,
      [e.target.name]:
        e.target.type === "checkbox"
          ? e.target.checked
          : ["notificationCount", "notificationTimeInterval"].includes(
              e.target.name
            )
          ? e.target.value.replace(/\D|^0/g, "")
          : e.target.value,
    }));
  };

  const handleSubmit = async () => {
    // if (
    //   formData.isEnable === true &&
    //   !Boolean(formData.notificationTimeInterval) &&
    //   !Boolean(formData.notificationCount)
    // ) {
    //   return alert(
    //     "Notification Time Interval And Notification count is required."
    //   );
    // }
    if (
      !Boolean(formData.notificationTimeInterval) ||
      !Boolean(formData.notificationCount)
    ) {
      return alert(
        "Notification Time Interval And Notification Count Are required."
      );
    }
    const payload = [
      {
        companyId: companyId,
        hrmsConfigurationName: "NOTIFICATION_TIME_CHECK_INTERVAL",
        configurationValue:
          formData.notificationTimeInterval === ""
            ? null
            : formData.notificationTimeInterval,
        // isActive: formData.isEnable,
        isActive: true,
      },
      {
        companyId: companyId,
        hrmsConfigurationName: "NOTIFICATION_SEND_COUNT_PER_COMPANY",
        configurationValue:
          formData.notificationCount === "" ? null : formData.notificationCount,
        // isActive: formData.isEnable,
        isActive: true,
      },
    ];
    const response = await companyWiseEmp.saveNotificationConfiguration(
      payload
    );
    if (response?.responseCode === 200) {
      alert(response.responseDescription);
    } else {
      alert(response?.responseDescription || response);
    }
  };

  React.useEffect(() => {
    if (gpsLocationStatusObj) {
      setFormData({
        notificationTimeInterval:
          gpsLocationStatusObj?.notificationTimeCheckInterval
            ?.configurationValue || "",
        notificationCount:
          gpsLocationStatusObj?.notificationCountCheckPerCompany
            ?.configurationValue || "",
        isEnable:
          gpsLocationStatusObj?.notificationTimeCheckInterval?.isActive &&
          gpsLocationStatusObj?.notificationCountCheckPerCompany?.isActive
            ? true
            : false,
      });
    }
  }, [gpsLocationStatusObj]);

  return (
    <div>
      {/* <Grid className="CompanyBox"> */}
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <Grid>
              <h3
                style={{
                  color: "#fff",
                  marginLeft: "10px",
                  padding: "10px 2px",
                }}
              >
                {/* GPS Notification Configuration:- */}
                GPS Loss Notification Configuration
              </h3>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid
              container
              direction="row"
              spacing={3}
              alignItems="center"
              style={{ marginTop: "2px" }}
            >
              <Grid item spacing={3}>
                <CustomInputField
                  sx={{ width: "100%", margin: "0px !important" }}
                  // required
                  value={formData.notificationTimeInterval}
                  // autoFocus
                  label="Notification Time Interval"
                  // placeholder="Location Tracking Interval"
                  name="notificationTimeInterval"
                  // variant="outlined"
                  size="small"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item spacing={3}>
                <CustomInputField
                  sx={{ width: "100%", margin: "0px !important" }}
                  // required
                  value={formData.notificationCount}
                  // autoFocus
                  label="Notification Count"
                  // placeholder="Location Tracking Interval"
                  // type="number"
                  name="notificationCount"
                  // variant="outlined"
                  size="small"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              {/* <Grid item spacing={3}>
                <Switch
                  name="isEnable"
                  checked={formData.isEnable}
                  onChange={handleChange}
                  color="secondary"
                />
              </Grid> */}
            </Grid>
            <Grid
              style={{
                placeItems: "center",
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "10px",
              }}
            >
              <div className="field_box">
                <div
                  className="field_box_btn1"
                  onClick={handleSubmit}
                  style={{
                    cursor: "pointer",
                    width: "60px",
                  }}
                >
                  Save
                </div>
              </div>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/* </Grid> */}
    </div>
  );
}

export default GpsNotificationConfiguration;
